import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const respuesta = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/respuesta`,
    state: {
        respuestas: []
    }
}).get({
    action: "get_respuestasbyavance",
    path: function (obj) {
        return `/avancenacional/${obj.idavancenacional}`;
    },
    onSuccess: (state, payload) => {
        state.respuestas = payload.data;
    }
}).getStore();

respuesta.getters = {
    grespuestas: state => {
        return state.respuestas
    }
}
export default respuesta;